import { JobStatus } from "@lib/enums";

export default function mapCandidatesToImportStatus(jobs) {
  const statuses = [
    JobStatus.IMPORTING_CV,
    JobStatus.FAILED,
    JobStatus.COMPLETE,
  ];
  return new Map(
    jobs
      .sort((a, b) => a.id - b.id)
      .filter(
        (job) => statuses.includes(job.status) && job.metadata?.candidate_id
      )
      .map((job) => [job.metadata.candidate_id, job.status])
  );
}
